export const archivedHistoryMessage =
  'Se quitará de la app y de esta lista, pero el historial se conserva.';

export function planEventRemoval(event) {
  if (!event) return { kind: 'noop' };
  if (!event.id) return { kind: 'local' };
  const marksCount = Number(event.marks_count) || 0;
  if (marksCount > 0) {
    const plural = marksCount === 1 ? '' : 's';
    return {
      kind: 'confirm',
      reason: 'active',
      title: `¿Quitar “${event.name}”?`,
      message: `Tiene ${marksCount} resultado${plural} guardado${plural}. ${archivedHistoryMessage}`,
      confirm: true,
    };
  }
  return { kind: 'delete', confirm: false };
}

export function planDeleteFailure(error, request) {
  const status = error?.response?.status;
  if (status === 409 && !request?.confirm) {
    return {
      kind: 'confirm',
      reason: 'archived',
      title: `¿Quitar “${request?.eventName || 'esta prueba'}”?`,
      message: archivedHistoryMessage,
      retry: false,
      success: false,
    };
  }
  return { kind: 'error', retry: false, success: false };
}
